/**
 * Helpers to reformat data
 */

var allCapsToProperCase = function allCapsToProperCase(text, force) {
	// handle incorrect data-type, like Null
	if (!text) return '';

	// IGNORE text that is already mixed case
	if (!force) {
		var mixedCase = text !== text.toUpperCase() && text !== text.toLowerCase();
		if (mixedCase) return text;
	}

	return text.toLowerCase().replace(/^(.)|[\s/-](.)/g, function ($1) {
		return $1.toUpperCase();
	});
};

export default allCapsToProperCase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@allpro/form-manager/es/formatters/formatProperCase.js
// module id = 531
// module chunks = 0